import React, { useState } from 'react'
import styles from './styles.module.scss'
import CloseIcon from '@material-ui/icons/Close'
import AsyncButton from 'utils/AsyncButton'
import { USER_DELETE_SUCCESS_MESSAGE, COGNITO_ERROR_MESSAGE } from 'const'
import { deleteUser, FetchedUser } from 'api/users'
import { useHistory } from 'react-router-dom'

export interface Props {
  closeModal: () => void
  selectedUser?: FetchedUser | undefined
}

const UserDeleteConfirmModal = ({ closeModal, selectedUser }: Props) => {
  const history = useHistory()
  const [isUserDeletionSubmitInProgress, setIsUserDeletionSubmitInProgress] = useState<boolean>(
    false
  )
  const userId: string | undefined = selectedUser?.userId
  const callDeleteUser = async () => {
    setIsUserDeletionSubmitInProgress(true)
    await deleteUser(userId)
      .then(() => {
        alert(USER_DELETE_SUCCESS_MESSAGE)
        history.go(0)
      })
      .catch((err) => {
        console.error(err)
        alert(COGNITO_ERROR_MESSAGE)
      })
    setIsUserDeletionSubmitInProgress(false)
  }

  return (
    <>
      <div className={styles.root}>
        <div>
          <CloseIcon fontSize="large" className={styles.closeImg} onClick={closeModal} />
        </div>
        <div className={styles.modalBox}>
          <p className={styles.header}>アカウントを削除してもよろしいですか？</p>
          <div className={styles.contentBox}>
            <AsyncButton
              type="button"
              variant="contained"
              color="secondary"
              className={styles.deleteButton}
              onClick={async () => {
                callDeleteUser()
              }}
              loading={isUserDeletionSubmitInProgress}
            >
              削除
            </AsyncButton>
          </div>
        </div>
      </div>
    </>
  )
}
export default UserDeleteConfirmModal
